<template slot="create">
  <target-form-upload
    :initialTarget="target"
    buttonText="Upload"
    @submit="handleUpload"
    @comsActivate="handleComsActivate"
    @activate="handleActivateTarget"
    ref="targetPartial"
    :errorMessage="errorMessage"
    :onComplete="onComplete"
    :originalTarget="originalTarget"
  ></target-form-upload>
</template>

<script>
import TargetFormUpload from './TargetFormUpload'
import {
  ACTIVATE_PID_NPOWER,
  MOVE_STAGED_FILE_TO_UPLOAD,
  SUBMITTING_PID_NPOWER,
  CREATE_TARGET
} from '@/appLogic/targets/createTarget/store/actions'
import {
  saveTarget
} from '@/api'
import {INTENTS,
  TARGET_TYPE,
  TARGET_TYPES_INTEGERS,
  ACTIVATION_STATUS
  } from '@/appLogic/targets/Constants'
import { SET_REFRESH_TABLE_FLAG } from '@/views/audienceHub/store/actions'

export default {
  components: {
    TargetFormUpload
  },
  props: {
    onCompleteUpload: {
      type: Function,
      default: () => {}
    },
    onComplete: {
      type: Function,
      default: () => {}
    },
    defaultSelectedUpload: {
      type: String,
      default: null
    },
    originalTarget: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      errorMessage: ''
    }
  },
  computed: {
    target () {
      return {
        display_name: '',
        target_datasource: null,
        advertiser: null,
        viewing_stream: null,
        target: this.defaultSelectedUpload,
        username: this.$store.state.auth.username,
        metadata: {intents: this.$store.state.createTarget && (this.$store.state.createTarget.intents || []).map(i => (INTENTS[i]))},
        ...(this.originalTarget || {})
      }
    }
  },
  methods: {
    handleActivateTarget (targetInfo) {
      const {file, target} = targetInfo
      this.$store.dispatch(ACTIVATE_PID_NPOWER, {target, file}).then(createdTarget => {
        this.onCompleteUpload(createdTarget)
      })
    },
    handleUpload (target_info) {
      let {file, target} = target_info
      if (file) {
        this.$store.dispatch(SUBMITTING_PID_NPOWER, {target, file, onComplete: this.onCompleteUpload})
        this.$emit('submittedUploadFile')
      } else {
        target.target = TARGET_TYPE.COMSCORE_TV
        target.target_datasource = TARGET_TYPE.COMSCORE_TV
        target.target_type = TARGET_TYPES_INTEGERS.COMSCORE_TV
        target.activation_status = ACTIVATION_STATUS.ACTIVATED
        this.$store.dispatch(SET_REFRESH_TABLE_FLAG, false)
        this.$store.dispatch(CREATE_TARGET, target).then(createdTarget => {
          this.$store.dispatch(SET_REFRESH_TABLE_FLAG, true)
        })
        this.$emit('sentDownstream')
      }
    },
  }
}

</script>

<style lang="scss">

.create-upload {
  height: 100%;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// CreateUpload.vue?04f8ae70